import { render, staticRenderFns } from "./course4.vue?vue&type=template&id=6c17665d&scoped=true&"
import script from "./course4.vue?vue&type=script&lang=js&"
export * from "./course4.vue?vue&type=script&lang=js&"
import style0 from "./course4.vue?vue&type=style&index=0&id=6c17665d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c17665d",
  null
  
)

export default component.exports